import { Anchor } from "@components/ResizableDrawer/ResizableDrawer"
import { useKeymap } from "@features/keymap/useKeymap"
import {
  Close,
  CloseFullscreen,
  CropSquareSharp,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material"
import { Grid, IconButton, SxProps, Theme, Tooltip } from "@mui/material"
import { ReactNode } from "react"

type ResizableDrawerNavigationBarProps = {
  anchor: Anchor
  onAnchorChange?: (newAnchor: Anchor) => void
  onClose?: () => void
  isMaximised: boolean
  onRestoreSize?: () => void
  onMaximise?: () => void
  menuComponent?: ReactNode
  title?: ReactNode
  sx?: SxProps<Theme>
}

const ResizableDrawerNavigationBar = (props: ResizableDrawerNavigationBarProps) => {
  const AnchorIcon = props.anchor === "bottom" ? KeyboardDoubleArrowRight : KeyboardDoubleArrowDown
  const keymap = useKeymap()

  return (
    <Grid
      container
      wrap="nowrap"
      sx={{
        border: "0px #ddd",
        borderStyle: "solid none",
        backgroundColor: "#fff",
        px: 1,
        ...props.sx,
      }}
      justifyContent="space-between"
    >
      {props.title && (
        <Grid item xs sx={{ minWidth: 0 }}>
          {props.title}
        </Grid>
      )}

      <Grid container item wrap="nowrap" justifyContent="flex-end" gap={1}>
        <Grid item>{props.menuComponent}</Grid>

        {props.onAnchorChange && (
          <Grid item>
            <Tooltip title={`Pin drawer to the ${props.anchor === "bottom" ? "right" : "bottom"}`}>
              <IconButton
                sx={{ p: 0 }}
                onClick={() =>
                  props.onAnchorChange!(props.anchor === "bottom" ? "right" : "bottom")
                }
              >
                <AnchorIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )}

        {props.onMaximise && props.onRestoreSize && (
          <>
            {props.isMaximised ? (
              <Grid item>
                <Tooltip title="Restore size">
                  <IconButton sx={{ p: 0 }} onClick={props.onRestoreSize}>
                    <CloseFullscreen fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : (
              <Grid item>
                <Tooltip title="Maximise">
                  <IconButton sx={{ p: 0 }} onClick={props.onMaximise}>
                    <CropSquareSharp fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </>
        )}

        {props.onClose && (
          <Grid item>
            <Tooltip title={keymap.getKeymaps().byId.get("close-drawer")?.desc}>
              <IconButton onClick={props.onClose} sx={{ p: 0 }}>
                <Close fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default ResizableDrawerNavigationBar
